/** @jsxRuntime classic */
/** @jsx jsx */
import React, { CSSProperties } from 'react';
import { jsx } from '@emotion/core';

import { Margins, Responsive } from 'src/design-system/style-types';

import style from './TextArea.style';

export interface Props {
  name?: string;
  className?: string;
  disabled?: boolean;
  err?: string | false;
  onBlur?: (event: React.FormEvent<HTMLTextAreaElement>) => void;
  onChange?: (event: React.FormEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  touched?: boolean;
  value?: string;
  marginBottom?: Responsive<Margins>;
  rows?: number;
  resize?: CSSProperties['resize'];
  size?: 'small' | 'normal';
  autoFocus?: boolean;
}

export const TextArea = (props: Props) => {
  const {
    className = '',
    disabled = false,
    name = '',
    onBlur = () => {},
    onChange = () => {},
    placeholder = '',
    value = '',
    rows,
    autoFocus = false,
  } = props;

  return (
    <textarea
      autoFocus={autoFocus}
      aria-labelledby={name}
      className={className}
      css={style.textarea(props)}
      disabled={disabled}
      id={name}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      value={value}
    />
  );
};
